import { NumberField } from '@calabriocloud/beacon-ui'
import { useTranslation } from 'react-i18next'
import { FieldProps } from './constants'

export const DurationField = ({ classifier, field: value, onChange }: FieldProps) => {
  const { t } = useTranslation()
  const baseValue = { classifierType: classifier.id, fieldKey: null }
  const field = value?.field ?? '0'

  const hours = Math.floor(parseInt(field) / 3600)
  const minutes = Math.floor((parseInt(field) % 3600) / 60)
  const seconds = parseInt(field) % 60

  const handleChange = (type: 'hour' | 'minute' | 'second') => (value: number) => {
    if (type === 'hour') {
      onChange({
        ...baseValue,
        field: (value * 3600 + minutes * 60 + seconds).toString(),
        name: `${t(classifier.name)} ${value.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`,
      })
    } else if (type === 'minute') {
      onChange({
        ...baseValue,
        field: (hours * 3600 + value * 60 + seconds).toString(),
        name: `${t(classifier.name)} ${hours.toString().padStart(2, '0')}:${value.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`,
      })
    } else {
      onChange({
        ...baseValue,
        field: (hours * 3600 + minutes * 60 + value).toString(),
        name: `${t(classifier.name)} ${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${value.toString().padStart(2, '0')}`,
      })
    }
  }

  return (
    <div className='flex flex-row gap-4 pb-4'>
      <NumberField data-testid='classifier-duration-hours-input' label={t('hoursv2')} minValue={0} maxValue={24} value={hours} onChange={handleChange('hour')}/>
      <NumberField data-testid='classifier-duration-mins-input' label={t('minsv2')} minValue={0} maxValue={60} value={minutes} onChange={handleChange('minute')}/>
      <NumberField data-testid='classifier-duration-seconds-input' label={t('secondsv2')} minValue={0} maxValue={60} value={seconds} onChange={handleChange('second')}/>
    </div>
  )
}
